<div class="trg-saving-overlay">
  <div class="trg-saving-overlay__content">
    <app-spinner *ngIf="spinner"></app-spinner>
  </div>
</div>
